// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3TU7c","loadingShrink":"PageLoading_loadingShrink__3yXsx"};